<template>
  <div>
    <landing-page-view
      v-if="isLpLoaded && isRendering"
      :input="lpData"></landing-page-view>
    <div v-else>
      <div class="min-height-page flex-middle flex-center">
        <spinner :size="10"></spinner>
      </div>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import LandingPageView from "@/client/applications/meitavlp/views/LandingPage.vue";
import useEventTracking from "@/client/applications/meitavlp/extensions/composition/useEventTracking";
import { provide } from "vue";
// load page by type async
export default {
  components: {
    LandingPageView,
  },

  middleware: {},
  props: {
    categoryAlias: {
      type: String,
      default: "",
    },
    lpAlias: {
      type: String,
      default: "",
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    password: {
      type: [String, Boolean],
      default: "",
    },
  },
  setup(props) {

    let { asyncOps, asyncOpsReady } = asyncOperations(props);
    let { setPage, track, trackEvent } = useEventTracking(props);
    let pageUid = utilities.getUniqueNumber();
    provide("track", trackEvent);
    provide("pageUid", pageUid);
    provide("trackEvent", trackEvent);
    return {
      asyncOps,
      asyncOpsReady,
      setPage,
      track,
      pageUid,
    };
  },
  data: function () {
    let lpTargetUrl = this.isPreview
      ? `landingPage/preview/${this.categoryAlias}/${this.lpAlias}`
      : `landingPage/${this.categoryAlias}/${this.lpAlias}`;

    return {
      isRendering: true,
      socket: null,
      lpData: false,
      asyncData: {
        lpData: {
          target: lpTargetUrl,
          data: {
            password: this.password,
          },
          options: {
            dataMutator: (data) => {
              this.setPage(data.item);
              return data.item;
            },
            errorHandler: "404",
            /*
           (res)  => {
           console.log('error');
           console.log(res);
           }//"404", //404,
           */
          },
        },
      },
    };
  },
  computed: {
    isLpLoaded() {
      return this.lpData !== false;
    },
  },
  mounted() {
    (async () => {
      if (!this?.$acl?.hasGroup("superUsers")) {
        return;
      }

      this.socket = await this.asyncOps.socket.init();
      await this.socket.waitForUUID();
      this.socket.on("landingPageUpdated", this.handlePageUpdatedOnServer);
    })();
  },
  beforeUnmount() {
    if (this.socket) {
      this.socket.off("refreshTokensRevokedRemotely");
    }
  },
  methods: {
    async handlePageUpdatedOnServer(data) {
      if (data.id !== this.lpData.id) {
        return;
      }
      this.$s.ui.globalSpinner.show();
      // this gives the backend time in case multiple sections are being modified.
      // todo: consider: have use case emit the update maybe? instead of the models triggering it
      await utilities.wait(1000);
      // make sure our data is not cached
      this.asyncOps.clearAllRequestDataFromCache();
      await this.refreshAsyncData();

      // force re-render
      this.isRendering = false;
      this.$nextTick(() => {
        this.isRendering = true;
        this.$s.ui.globalSpinner.hide();
        this.$s.ui.notification.closeAll();
        this.$s.ui.notification("lp.admin.lpUpdateLiveNotificationText", "info", {
          title: "lp.admin.lpUpdateLiveNotificationTitle",
          duration: 2000,
        });
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
